@if (variant() === 'text-only') {
  <span class="selection-label" joii-text [size]="labelTextSize()" [weight]="'regular'" [color]="'form-text-default'">{{
    label()
  }}</span>
} @else if (variant() === 'avatar') {
  <joii-avatar class="selection-avatar" [variant]="avatarVariant()" [src]="avatarSrc()" [size]="avatarSize()" />
  <span class="selection-label" joii-text [size]="labelTextSize()" [weight]="'regular'" [color]="'form-text-default'">{{
    label()
  }}</span>
} @else if (variant() === 'icon') {
  <span class="selection-icon-container">
    <svg class="selection-icon" [lucideIcon]="icon() ?? null" [size]="iconSize()" />
  </span>
  <span class="selection-label" joii-text [size]="labelTextSize()" [weight]="'regular'" [color]="'form-text-default'">{{
    label()
  }}</span>
}
